import { createContext, useContext, useState } from 'react';
import { Bookmark, BookmarkCheck } from 'lucide-react';
import { journalEntries } from '../../data/journal';

const ReadingListContext = createContext(null);
const STORAGE_KEY = 'aetherios-reading-list';
const validSlugs = new Set(journalEntries.map(entry => entry.slug));

export const ReadingListProvider = ({ children }) => {
  const [unavailable, setUnavailable] = useState(false);
  const [saved, setSaved] = useState(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(stored) ? [...new Set(stored.filter(slug => validSlugs.has(slug)))] : [];
    } catch { return []; }
  });
  const toggle = slug => {
    if (!validSlugs.has(slug)) return;
    const next = saved.includes(slug) ? saved.filter(item => item !== slug) : [...saved, slug];
    setSaved(next);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); setUnavailable(false); }
    catch { setUnavailable(true); }
  };
  return <ReadingListContext.Provider value={{ saved, toggle, unavailable }}>{children}</ReadingListContext.Provider>;
};

export const useReadingList = () => useContext(ReadingListContext);

export const SaveNote = ({ slug, testId, showLabel = false }) => {
  const { saved, toggle } = useReadingList();
  const isSaved = saved.includes(slug);
  const title = journalEntries.find(entry => entry.slug === slug)?.title || 'This note';
  return <button className={`save-note ${isSaved ? 'is-saved' : ''}`} onClick={() => toggle(slug)} aria-label={isSaved ? `Remove ${title} from reading list` : `Save ${title} on this device`} aria-pressed={isSaved} title={isSaved ? 'Saved on this device' : 'Save for later on this device'} data-testid={testId}>{isSaved ? <BookmarkCheck size={16} /> : <Bookmark size={16} />}{showLabel && <span>{isSaved ? 'Saved on this device' : 'Save for later'}</span>}</button>;
};

export const StorageNotice = () => {
  const { unavailable } = useReadingList();
  return unavailable ? <p className="journal-storage-notice" role="status" data-testid="reading-list-storage-note">Browser storage is unavailable. Your reading list will last for this visit only.</p> : null;
};